export default __webpack_public_path__ + "static/media/Ilogo.0228f760.svg";